class Spreadsheet {
  constructor(id) {
    this.id = id;
    this._detail = null;
  }

  client() {
    return window.gapi.client.sheets.spreadsheets;
  }

  async getDetail(params = {}) {
    try {
      const response = await this.client().get({
        ...params,
        spreadsheetId: this.id,
      });

      return (this._detail = response.result);
    } catch (error) {
      throw new Error(error.result.error.message);
    }
  }

  async readRange(range, params = {}) {
    try {
      const response = await this.client().values.get({
        ...params,
        range,
        spreadsheetId: this.id,
      });

      return response.result.values;
    } catch (error) {
      throw new Error(error.result.error.message);
    }
  }

  async append({ sheet, value, ...params }) {
    try {
      const response = await this.client().values.append({
        ...params,
        spreadsheetId: this.id,
        range: sheet,
        resource: { values: [value] },
      });

      return response.result.updates;
    } catch (error) {
      throw new Error(error.result.error.message);
    }
  }

  async updateRow({ sheet, index, value, ...params }) {
    try {
      const response = await this.client().values.update({
        ...params,
        range: `${sheet}!${index + 1}:${index + 1}`,
        spreadsheetId: this.id,
        resource: { values: [value] },
      });

      return response.result;
    } catch (error) {
      throw new Error(error.result.error.message);
    }
  }

  async deleteRow({ sheet, index }) {
    const sheetId = await this.getSheetIdFor(sheet);

    if (sheetId == undefined) {
      throw new Error(`Unable to parse range: ${sheet}`);
    }

    try {
      const response = await this.client().batchUpdate({
        spreadsheetId: this.id,
        resource: {
          requests: [
            {
              deleteDimension: {
                range: {
                  sheetId,
                  dimension: 'ROWS',
                  startIndex: index,
                  endIndex: index + 1,
                },
              },
            },
          ],
        },
      });

      return response.result;
    } catch (error) {
      throw new Error(error.result.error.message);
    }
  }

  async getSheetIdFor(sheet) {
    if (this._detail == null) {
      await this.getDetail();
    }

    for (let i = 0; i < this._detail.sheets.length; i++) {
      if (
        sheet.toLowerCase() ==
        this._detail.sheets[i].properties.title.toLowerCase()
      ) {
        return this._detail.sheets[i].properties.sheetId;
      }
    }
  }
}

export default Spreadsheet;
